import { render, staticRenderFns } from "./system_school_infomation_detail.vue?vue&type=template&id=aff86b5e&"
import script from "./system_school_infomation_detail.vue?vue&type=script&lang=js&"
export * from "./system_school_infomation_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports